import { render, staticRenderFns } from "./properties-form.vue?vue&type=template&id=7cb95118&scoped=true"
import script from "./properties-form.vue?vue&type=script&lang=js"
export * from "./properties-form.vue?vue&type=script&lang=js"
import style0 from "./properties-form.vue?vue&type=style&index=0&id=7cb95118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb95118",
  null
  
)

export default component.exports